import { useContext, useState, useEffect } from 'react';
import { AdsContext } from '@buzzfeed/adlib/dist/module/bindings/react/contexts';
import AdUnit from '../../AdUnit';
import { useGameInterstitialAd, GAME_INTERSTITIAL_PREFETCH_EVENT } from '../../../../hooks/useGameInterstitialAd';

/**
 * Unified game interstitial ad unit for broadcast-driven games
 * (word chain, huedoku, future games).
 *
 * Mounts <AdUnit> when either:
 * - prefetchOnMount games (e.g. huedoku): immediately when experiment is non-control
 * - other games (e.g. word chain): on GAME_INTERSTITIAL_PREFETCH_EVENT from eventBus
 */
function GameInterstitialAdUnit() {
  const adsContext = useContext(AdsContext);
  const { enabled, prefetchOnMount } = useGameInterstitialAd();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (enabled && prefetchOnMount) {
      setReady(true);
    }
  }, [enabled, prefetchOnMount]);

  useEffect(() => {
    if (prefetchOnMount || !enabled || !adsContext?.eventBus) return;
    const onPrefetch = () => setReady(true);
    adsContext.eventBus.on(GAME_INTERSTITIAL_PREFETCH_EVENT, onPrefetch);
    return () => adsContext.eventBus.off(GAME_INTERSTITIAL_PREFETCH_EVENT, onPrefetch);
  }, [prefetchOnMount, enabled, adsContext?.eventBus]);

  if (!ready || !enabled) return null;

  return <AdUnit type="game-interstitial" />;
}

export default GameInterstitialAdUnit;
